'use client'

import 'react-toastify/dist/ReactToastify.css'
import './toastify.css'

import { useTheme } from 'next-themes'
import { Slide, ToastContainer } from 'react-toastify'
import { tv } from 'tailwind-variants'

const toastVariants = tv({
  base: ' flex cursor-pointer gap-4 overflow-hidden border-none p-2.5 shadow-md sm:rounded-sm',
  variants: {
    type: {
      success: 'bg-success text-success-foreground shadow-success-300',
      error: 'bg-error text-error-foreground shadow-error-300',
      warning: 'bg-warning text-warning-foreground shadow-warning-300',
      info: 'bg-info text-info-foreground shadow-info-300',
      default: 'bg-primary text-primary-foreground shadow-primary-300',
    },
  },
  defaultVariants: {
    type: 'default',
  },
})

const progressVariants = tv({
  base:
    'z-1 Toastify__progress-bar--animated absolute bottom-0 h-full'
    + ' w-full origin-[0] sm:w-[calc(100%_-_var(--toastify-width-offset)*2)]'
    + ' sm:ml-1.5 sm:rounded-lg',
  variants: {
    type: {
      success: 'bg-success-200',
      error: 'bg-error-200',
      warning: 'bg-warning-200',
      info: 'bg-info-200',
      default: 'bg-primary-200',
    },
  },
})

export const ToastifyProvider = () => {
  const { theme } = useTheme()

  return (
    <ToastContainer
      stacked
      autoClose={2500}
      bodyClassName={() => 'flex flex-auto items-center text-xs p-1.5'}
      closeButton={true}
      draggable="mouse"
      draggablePercent={40}
      limit={10}
      pauseOnFocusLoss={false}
      theme={theme}
      transition={Slide}
      progressClassName={
        (context) => {
          return progressVariants({
            type: context?.type,
          })
        }
      }
      toastClassName={
        (context) => {
          return toastVariants({ type: context?.type })
        }
      }
    />
  )
}
